import { createContext } from 'react';

export const ModelContext = createContext({
  getModels: null,
  getTeamData: null,
  pageTitle: '',
  sortingOptions: [],
  searchParam: '',
  searchCategoryParam: '',
  searchSubcategoryParam: '',
});
